export default __webpack_public_path__ + "static/media/ron-rambell-logo-lay.522a5204.png";